/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { INCLUDE_IMPEDANCE_LONG_LEAD_TIME } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import RepairTimeOptionsSection from './RepairTimeOptionsSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const { selectFormValues } = modelTypesByForm[form];
  return {
    showIncludeImpedanceLongLeadTimeWarning:
      selectFormValues(state, INCLUDE_IMPEDANCE_LONG_LEAD_TIME) === false,
  };
};

export default connect(mapStateToProps)(RepairTimeOptionsSection);
